module.exports = __webpack_public_path__ + "static/media/vespa.d9ab4098.png";